import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppDispatch, GetAppState } from "../store";
import { Plan } from "./plans";

export type RecommendedPlanState = Partial<Plan>;
const recommendedPlansSlice = createSlice({
  name: "recommendedPlan",
  initialState: {} as RecommendedPlanState,
  reducers: {
    setRecommendedPlan: (
      state,
      action: PayloadAction<RecommendedPlanState>
    ) => {
      return action.payload;
    },
    updateRecommendedPlan: (
      state,
      action: PayloadAction<RecommendedPlanState>
    ) => {
      // Does have partial updates
      return { ...state, ...action.payload };
    },
  },
});

export const { setRecommendedPlan, updateRecommendedPlan } =
  recommendedPlansSlice.actions;

export default recommendedPlansSlice.reducer;

export function setRecommendPlanById(noomPlanId: string) {
  return (dispatch: AppDispatch, getState: GetAppState) => {
    const { plans } = getState();
    const recommendedPlan = Object.values(plans).find(
      (plan) => plan.noom_plan_id === noomPlanId
    );
    if (!recommendedPlan) {
      throw new Error(`No plan found with noom_plan_id: ${noomPlanId}`);
    }

    dispatch(setRecommendedPlan(recommendedPlan));
  };
}
